import React from 'react';
import { Building2 } from 'lucide-react';
import { IntelligenceProfile } from '../../types';

interface BusinessProfileSectionProps {
  profile: IntelligenceProfile;
  className?: string;
}

export const BusinessProfileSection: React.FC<BusinessProfileSectionProps> = ({
  profile,
  className = ""
}) => {
  return (
    <div className={`p-3 bg-blue-50 rounded-lg border-l-4 border-l-blue-400 ${className}`}>
      <h4 className="text-sm font-semibold text-blue-900 mb-3 flex items-center">
        <Building2 className="h-4 w-4 mr-2" />
        Business Profile
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div>
          <p className="text-xs text-blue-700 mb-1">Industry</p>
          <p className="text-sm font-medium text-gray-900">
            {profile.industry_name || profile.industry_id}
          </p>
        </div>
        {profile.annual_revenue && (
          <div>
            <p className="text-xs text-blue-700 mb-1">Annual Revenue</p>
            <p className="text-sm font-medium text-gray-900">{profile.annual_revenue}</p>
          </div>
        )}
        {profile.company_size && (
          <div>
            <p className="text-xs text-blue-700 mb-1">Company Size</p>
            <p className="text-sm font-medium text-gray-900">{profile.company_size}</p>
          </div>
        )}
        <div>
          <p className="text-xs text-blue-700 mb-1">Completion</p>
          <p className="text-sm font-semibold text-blue-600">
            {profile.completion_score || 0}%
          </p>
        </div>
      </div>
    </div>
  );
};